

export class ProjectFiles {


    static readonly LEFT_COLUMN_BACKGROUND = '../images/icons/Sol_color.png'
}



export class Constants {
    public static readonly DEFAULT_CAMPAIGN_TIME_OPTIONS_COUNT = 10
    public static readonly CAMPAIGN_TIME_OPTIONS_NIGHTTIME_THRESHOLD = 360 // in minutes
    public static readonly CAMPAIGN_TIME_NIGHTTIME_EXPAND = 240 // in minutes

    public static readonly AWAIT_REFRESH_TOKEN_MAX_DURATION = 5000
    public static readonly AWAIT_REFRESH_TOKEN_GRANULARITY = 1000


    public static readonly COMPANY_SEGMENT_OPTIONS = [
        { value: "option1", label: "Akdeniz Mutfağı" },
        { value: "option2", label: "Atıştırmalık" },
        { value: "option3", label: "Börek" },
        { value: "option4", label: "Çiğ Köfte" },
        { value: "option5", label: "Çin Mutfağı" },
        { value: "option6", label: "Çorba" },
        { value: "option7", label: "Deniz Ürünleri" },
        { value: "option8", label: "Döner" },
        { value: "option9", label: "Dondurma" },
        { value: "option10", label: "Dünya Mutfağı" },
        { value: "option11", label: "Ev Yemekleri" },
        { value: "option12", label: "Et ve Köfte" },
        { value: "option13", label: "Fast Food" },
        { value: "option14", label: "Hamburger" },
        { value: "option15", label: "İtalyan Mutfağı" },
        { value: "option16", label: "Japon mutfağı" },
        { value: "option17", label: "Kahvaltı" },
        { value: "option18", label: "Kahve Dükkanı" },
        { value: "option19", label: "Kebap" },
        { value: "option20", label: "Kokoreç" },
        { value: "option21", label: "Makarna" },
        { value: "option22", label: "Mantı" },
        { value: "option23", label: "Meze" },
        { value: "option24", label: "Midye" },
        { value: "option25", label: "Orta Doğu Mutfağı" },
        { value: "option26", label: "Pastane" },
        { value: "option27", label: "Pide" },
        { value: "option28", label: "Pilav" },
        { value: "option29", label: "Pizza" },
        { value: "option30", label: "Söğüş" },
        { value: "option31", label: "Sushi" },
        { value: "option32", label: "Tatlı" },
        { value: "option33", label: "Tavuk" },
        { value: "option34", label: "Tost" },
        { value: "option35", label: "Türk Mutfağı" },
        { value: "option36", label: "Vegan / Vejeteryan" },
        { value: "option37", label: "Özel Mutfak" }

        

    ]

    public static readonly COMPANY_TYPE_OPTIONS = [
        { value: "option1", label: "Restoran" },
        { value: "option2", label: "Büfe" },
        { value: "option3", label: "Yemekhane" },
        { value: "option4", label: "Kafe" },
        { value: "option5", label: "Kiosk" }
    ]
}


export class Formats {
    public static readonly PROJECT_DATE_FORMAT = "DD/MM/YYYY HH:mm:ss"
}


export class PremadeRegex {
    public static readonly DECIMAL_REGEX = /^\d*\.?\d*$/;
}

